import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { Box, Typography } from '@mui/material';

import { Border, Container } from './styles';

const CardSet = ({ activeMembers }) => {
  const countByRole = activeMembers.reduce((acc, member) => {
    acc[member.dashboardRole] = (acc[member.dashboardRole] || 0) + 1;
    return acc;
  }, { total: activeMembers.length });

  const cards = [
    {
      header: 'Members',
      title: countByRole.total,
      minWidth: '400px',
    },
    {
      header: 'Owners',
      title: countByRole.owner || 0,
      minWidth: '100px',
    },
    {
      header: 'Admins',
      title: countByRole.admin || 0,
      minWidth: '100px',
    },
    {
      header: 'Editors',
      title: countByRole.editor || 0,
      minWidth: '100px',
    },
    {
      header: 'Viewers',
      title: countByRole.viewer || 0,
      minWidth: '100px',
    },
  ];

  return (
    <Container>
      {cards.reduce((acc, card, i) => {
        acc.push(
          <Box key={card.header} sx={{ minWidth: card.minWidth, marginLeft: 2 }}>
            <Typography
              variant="h3"
              component="p"
              sx={{ marginBottom: 2 }}
            >{card.header}
            </Typography>
            <Typography
              sx={theme => ({ fontSize: theme.typography.h1.fontSize })}
              component="p"
            >{card.title}
            </Typography>
          </Box>,
        );
        if (i !== cards.length - 1) {
          acc.push(
            <div
              key={`card-spacer-${card.header}`}
            >
              <Border />
            </div>,
          );
        }
        return acc;
      }, [])}
    </Container>
  );
};

export default CardSet;

CardSet.propTypes = {
  activeMembers: arrayOf(shape({
    id: string,
    dashboardRole: string,
  })).isRequired,
};
